import { Mountable } from '../types';

const _target = Symbol('target');

class EventData<T extends Mountable> {

  [_target]: T;

  get target(): T {
    return this[_target];
  }
}

function setTarget<T extends Mountable>(instance: EventData<T>, target: T): void {
  instance[_target] = target;
}

export { EventData as default, setTarget };
